import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const LOGO =
  "https://customer-assets-lqy194kg.emergentagent.net/job_5d29195d-8343-48d3-b6be-1f5b54748a24/artifacts/1ncupiqd_b571415c-e2ad-4050-9788-1f8f79ff7344.jpg";
export const FOTO_DANIELA =
  "https://customer-assets-lqy194kg.emergentagent.net/job_5d29195d-8343-48d3-b6be-1f5b54748a24/artifacts/3pqfgmou_7c3fff2e-8895-46fe-823f-e501980e19b2.jpg";
export const LIBRO =
  "https://customer-assets-lqy194kg.emergentagent.net/job_5d29195d-8343-48d3-b6be-1f5b54748a24/artifacts/dh1r6vsk_0c88228e-57d2-4af2-a560-ab08233070a9.png";
export const WHATSAPP = "https://wa.me/5402262484516";

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("nilo_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const errMsg = (e) =>
  e?.response?.data?.detail || e?.message || "Ocurrio un error";
